<template>
  <v-app>
    <v-container class="grey lighten-5">
      <v-row class="justify-center">
        <v-col class="col-12 col-md-11">
          <h2 class="text-left primary--text ml-4">
            <v-icon class="primary--text mr-2">record_voice_over</v-icon>Pacientes
          </h2>

          <div class="row">
            <div
              class="col-12 col-md-4 col-paciente"
              v-for="(item, index) in listPatients"
              :key="index"
            >
              <div
                class="box-paciente d-flex flex-row align-center justify-space-between px-3 py-5"
              >
                <div class="d-flex flex-row align-center ml-2 mr-2">
                  <img :src="item.photo" class="img-paciente mr-2" />
                  <h2 class="ma-0 gray--text paciente-nome">{{item.name}}</h2>
                </div>
                <v-btn class="bt-perfil" @click="goProfilePatients(item.id)">Ver Perfil</v-btn>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import http from '@/services/httpClient';

export default {
  data() {
    return {
      cod: '',
      listPatients: [],
    };
  },
  async created() {
    await this.getCod();
    await this.getListPatients();
  },
  methods: {
    getCod() {
      this.cod = localStorage.getItem('user-id');
    },
    async getListPatients() {
      try {
        const { data, status } = await http.get(
          `/psychologists/${this.cod}/patients/`,
          {
            headers: {
              Authorization: `Token ${localStorage.getItem('user-token')}`,
            },
          },
        );
        if (status == 200) {
          this.listPatients = data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    goProfilePatients(id) {
      this.$router.push({ name: 'PacienteProfile', params: { id } });
    },
  },
};
</script>

<style lang="css" scoped>
.toolbar {
  height: auto;
}

.v-toolbar__content {
  height: auto !important;
}

.my__toolbar {
  height: auto;
}

.bt-perfil {
  font-size: 0.5rem;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.box-paciente {
  width: 100%;
  border-radius: 5px;
}

.col-paciente:nth-child(odd) .box-paciente {
  background-color: #fffde3;
}

.paciente-nome {
  font-size: 1rem;
}

/* .col-paciente:nth-child(2n+1) .box-paciente {
  background-color: #FFFDE3;
} */

.box-paciente img {
  width: 55px;
  height: 55px;
  border-radius: 50% !important;
  border: 1px solid #ccc;
}

@media screen and (max-width: 420px) {
  .my__toolbar img {
    width: 50%;
  }
}
</style>
